import CardUpNext from '@ifit/mp-card-up-next';
import { useContext } from 'react';
import { getUserNavigationHandler, ROWTITLES } from '../../util/navigation-utils';
import { getResizedImageUrl } from '../../util/get-resized-image-url';
import { IRecommendedWorkoutsAndDetails } from './index';
import { useDeviceType } from '../../state-management/selectors/use-device-type';
import { DefaultImages } from '@ifit/img/out/defaults';
import { ThemeContext } from '@ifit/themes/ThemeContext';

interface IRecommendedWorkoutItemProps {
  item: IRecommendedWorkoutsAndDetails;
}

export function getSizedWorkoutItemImageUrl(imageUrl: string, deviceType: string): string {
  const dimensions =
    deviceType === 'mobile'
      ? {
          width: 328,
          height: 440,
        }
      : {
          width: 688,
          height: 768,
        };

  return getResizedImageUrl(imageUrl, DefaultImages.LargeCard, dimensions);
}

export default function RecommendedWorkoutItem(props: IRecommendedWorkoutItemProps): JSX.Element {
  const { workout, userWorkoutDetail } = props.item;
  const { averageRating, imageUrl, title, isLive, callToAction, leadLine, intensityText, navigationUrl } = workout;
  const { theme } = useContext(ThemeContext);

  const clickHandler = getUserNavigationHandler(navigationUrl, ROWTITLES.RECOMMENDED_WORKOUTS_ITEM);

  return (
    <CardUpNext
      imageUrl={getSizedWorkoutItemImageUrl(imageUrl, useDeviceType())}
      isLive={isLive}
      tagPrimary={intensityText}
      title={title}
      averageRating={averageRating}
      callToAction={callToAction}
      callToActionShort={callToAction}
      colorScheme={theme === 'VAULT' ? 'vault' : null}
      leadLine={leadLine}
      onClick={clickHandler}
      locked={userWorkoutDetail?.locked}
    />
  );
}
